import { render } from "./resultPage.vue?vue&type=template&id=4c529c86"
import script from "./resultPage.vue?vue&type=script&lang=js"
export * from "./resultPage.vue?vue&type=script&lang=js"

import "./resultPage.vue?vue&type=style&index=0&lang=stylus"
script.render = render

export default script